/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type StatsSummaryResponse = {
  request_statistics: {
    request_count: number;
    request_unsafe_count: number;
    request_error_count: number;
    request_unsafe_rate: number;
    violation_type_counts: Record<string, number>;
    policies_violation_counts: Record<string, number>;
    unsafe_request_counts_by_max_risk: Record<string, number>;
  };
  request_latency_metrics: {
    avg_response_time_ms: number;
    max_response_time_ms: number;
    p95_response_time_ms: number;
    p99_response_time_ms: number;
  };
  last_error_timestamp?: string;
};

export type StatsSummaryRequestType = {
  params: {
    start_at: string;
    end_at: string;
    service_token_id?: string;
  };
  token: string;
};

export default function getStatsSummary({
  params,
  token,
}: StatsSummaryRequestType): Promise<InternalResponse<StatsSummaryResponse>> {
  return request()({
    url: "/xecguard/v1/stats/summary",
    method: "GET",
    params,
    headers: authHeaders(token),
  })
    .then(
      (result: AxiosResponse<StatsSummaryResponse>): InternalResponse<StatsSummaryResponse> => ({
        statusCode: result.status,
        data: result.data,
        success: true,
      }),
    )
    .catch(
      (error: AxiosError): InternalResponse => ({
        statusCode: error.code,
        msg: error.message,
        success: false,
      }),
    );
}
